// @see https://github.com/mfranzke/loading-attribute-polyfill
// @see https://github.com/WICG/focus-visible
import bodyClass from "./body-class";
import "loading-attribute-polyfill";
import "./classlist-polyfill";
import "focus-visible";
import radioFilterSelector from "./radio-filters";
import ajaxForm from "./ajax-form";
import "./dialog";
import animation from "./observe-animation";
import stackTabs from "./stack-tabs";
import vps from "./vps";
import switcher from "./switch";
import carousel from "./carousel";

// Global events
document.addEventListener(
  "DOMContentLoaded",
  () => {
    bodyClass(); // Touch device
    radioFilterSelector(); // Simulator
    animation(".illus-anim"); // SVG animations
    ajaxForm(); // Contact
    stackTabs(); // Simulator
    vps(); // Simulator fix
    switcher(); // Home prices switch
    carousel(); // Home screenshots carousel
  },
  false
);
